import { CardContent as MuiCardContent } from '@mui/material';
import React, { FC } from 'react';
import { Theme, useTheme } from '@mui/material/styles';

interface IProps {
  gutter?: 1 | 2 | false;
  contentJustification: 'flex-start' | 'center' | 'flex-end';
  color?: string;
  override?: any;
  children?: React.ReactNode;
}

const useStyles = (theme: Theme, { gutter, contentJustification, color, override }: IProps) => ({
  root: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center',
    justifyContent: `${contentJustification} !important`,
    position: 'absolute !important',
    inset: '0 !important',
    padding: !gutter ? 0 : `${theme.spacing(gutter)} !important`,
    '&:lastChild': {
      padding: !gutter ? 0 : `${theme.spacing(gutter)} !important`,
    },
    color: color || 'inherit !important',
    ...override,
  },
});

export const CardContent: FC<IProps> = ({
  children,
  gutter,
  contentJustification,
  color,
  override = {},
}) => {
  const theme = useTheme();
  const classes = useStyles(theme, {
    gutter,
    contentJustification,
    color,
    override,
  });

  return (
    <MuiCardContent style={classes.root}>{children}</MuiCardContent>
  );
};
